import { FirebaseOptions } from '@firebase/app';

export enum Environment {
    PRODUCTION = 'production', // Live production server
    DEV_SERVER = 'development', // Development server
    LOCAL = 'local', // Local development environment
    TESTING = 'testing' // Tests
}

export interface EnvironmentInterface {
    environment: Environment;
    production: boolean;
    apiUrl: string;
    website: string;
    webappUrl: string;
    tokenKey: string;
    googleMapsApiKey: string;
    googleMapsId: string;
    firebaseConfig: FirebaseOptions;
    sentryDsn: string;
}

export const isDevelopmentEnvironment = (env: EnvironmentInterface): boolean => {
    return (
        env.environment === Environment.LOCAL ||
        env.environment === Environment.TESTING ||
        env.environment === Environment.DEV_SERVER
    );
};
